import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { HomeLayoutRoutingModule } from './home-layout-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

// Components
import { HomeLayoutComponent } from './home-layout.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { HotelDetailsComponent } from './hotel/hotel-details/hotel-details.component';
import { BrandDevelopmentComponent } from './pages/brand-development/brand-development.component';
import { BrandAdvantageComponent} from './pages/brand-advantage/brand-advantage.component';
import { MeetingEventsComponent } from './pages/meeting-events/meeting-events.component';
import { FaqsComponent } from './pages/faqs/faqs.component';

// Loyalty Components
import { LoyaltyRegisterComponent } from './loyalty/loyalty-register/loyalty-register.component';
import { UserLoginComponent } from './loyalty/user-login/user-login.component';
import { ForgotPasswordComponent } from './loyalty/forgot-password/forgot-password.component';
import { VerifyUserComponent } from './loyalty/verify-user/verify-user.component';

import { AuthGuard } from './loyalty/auth.guard';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

@NgModule({
  declarations: [
    HomeLayoutComponent, 
    HomeComponent, 
    HeaderComponent, 
    FooterComponent, 
    HotelDetailsComponent, 
    BrandDevelopmentComponent, 
    BrandAdvantageComponent,
    MeetingEventsComponent,
    FaqsComponent,
    LoyaltyRegisterComponent,
    UserLoginComponent,
    ForgotPasswordComponent,
    VerifyUserComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    CommonModule,
    HomeLayoutRoutingModule,
    SharedModule,
    NgxDaterangepickerMd.forRoot(),
    NgbAccordionModule
  ],
  providers: [AuthGuard]
})
export class HomeLayoutModule { }
